import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const purchases = [{
  name: 'Carlos M.',
  location: 'Buenos Aires',
  time: 'Hace 2 minutos'
}, {
  name: 'Valeria G.',
  location: 'Córdoba',
  time: 'Hace 5 minutos'
}, {
  name: 'Martín F.',
  location: 'Rosario',
  time: 'Hace 12 minutos'
}, {
  name: 'Laura P.',
  location: 'Mendoza',
  time: 'Hace 18 minutos'
}, {
  name: 'Agustín R.',
  location: 'Santa Fe',
  time: 'Hace 25 minutos'
}];
export function SocialProofToast() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    let hideTimer: NodeJS.Timeout;
    let showTimer: NodeJS.Timeout;
    if (isVisible) {
      hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    } else {
      const nextDelay = Math.floor(Math.random() * 10000) + 15000;
      showTimer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchases.length);
        setIsVisible(true);
      }, nextDelay);
    }
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(showTimer);
    };
  }, [isVisible]);
  const currentPurchase = purchases[currentIndex];
  return <AnimatePresence data-id="element-360">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto" data-id="element-361">
          <div className="bg-white border border-[#e2e8f0] rounded-xl shadow-xl p-4 pr-10 relative flex items-start gap-3" data-id="element-362">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-[#475569] hover:text-[#0f172a]" data-id="element-363">
              <X size={16} data-id="element-364" />
            </button>

            <div className="bg-[#22c55e]/10 p-2 rounded-full shrink-0 mt-0.5" data-id="element-365">
              <CheckCircle2 size={20} className="text-[#22c55e]" data-id="element-366" />
            </div>

            <div data-id="element-367">
              <p className="text-xs text-[#16a34a] font-black mb-1 uppercase tracking-wider" data-id="element-368">
                Compra verificada
              </p>
              <p className="text-sm text-[#0f172a] leading-tight mb-1 font-medium" data-id="element-369">
                <span className="font-black" data-id="element-370">{currentPurchase.name}</span> (
                {currentPurchase.location}) compró Sistema Escapista Pro 💰
              </p>
              <p className="text-xs text-[#475569] font-bold" data-id="element-371">
                {currentPurchase.time}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}